import React from 'react';
import './Testimonial.css';
import bgImg from '../../images/testimonial/testimonial-bg.webp';
import img1 from '../../images/testimonial/1.jfif';
import img2 from '../../images/testimonial/2.png';
import img3 from '../../images/testimonial/3.png';
const Testimonial = () => {
    return (
        <div className="container testimonial-block" id='Testimonials' style={{ backgroundImage: `url(${bgImg})`, backgroundSize: 'cover', width: '100%', borderRadius: '5px' }}>
            <h1 className='text-center testimonial'>Testimonials</h1>
            <div className="row">
                <div className="col-12 testimonial-content">
                    <div id="carouselExampleIndicators" className="testimonial-carousel carousel slide text-center" data-ride="carousel">
                        <ol className="carousel-indicators">
                            <li data-target="#carouselExampleIndicators" data-slide-to="0" className="active"></li>
                            <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                            <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                        </ol>
                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <p className="testimonial-content">They provide good quality of dry fruit , especially almonds and also at very affordable prices as compare to other market price.</p>
                                <div className="row">
                                    <div className="reviewed-person col-md-4 " style={{ textAlign: 'right' }}>
                                        <img className='carousel-img' src={img1} alt="" />
                                    </div>
                                    <div className="reviewed-person col-md-8 ">
                                        <h4 className="r-d testimonial-content-person">Ariful Islam</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="carousel-item">
                                <p className="testimonial-content">Wide variety of products to choose from , also very prompt staff, all together good experience.</p>
                                <div className="row">
                                    <div className="reviewed-person col-md-4" style={{ textAlign: 'right' }}>
                                        <img className='carousel-img' src={img2} alt="" />
                                    </div>
                                    <div className="reviewed-person col-md-8 ">
                                        <h4 className="r-d testimonial-content-person">Jahedul Islam</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="carousel-item">
                                <p className="testimonial-content">They offer world class quality of dry fruits. I have known them for a long time</p>
                                <div className="row">
                                    <div className="reviewed-person col-md-4" style={{ textAlign: 'right' }}>
                                        <img className='carousel-img' src={img3} alt="" />
                                    </div>
                                    <div className="reviewed-person col-md-8 ">
                                        <h4 className="r-d testimonial-content-person">Shoriful Islam</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            {/* <span className="sr-only"></span> */}
                        </a>
                        <a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            {/* <span className="sr-only"></span> */}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Testimonial;